import * as yup from "yup";

// birthdate: yup.date()
// .max(new Date(Date.now() - 567648000000), "You must be at least 18 years")
// .required("Required"),

export const baseSchema = yup.object().shape({
  business_name: yup
    .string()
    .min(5, "business name must be at least 5 characters")
    .required("please enter business name"),
  business_type: yup
    .string()
    .min(5, "business type must be at least 5 characters")
    .required("please enter business type"),
  number_of_customer: yup
    .number()
    .positive("number of customer must be a positive number")
    .integer()
    .required("please enter number of customers"),
  target_category: yup
    .string()
    .oneOf(
      ["Employees", "Customers"],
      "target category must be one of the following values: Employees, Customers"
    )
    .required("please choose target category"),
});

export const contactSchema = yup.object().shape({
  email: yup.string().email().required("please enter email address"),
  town: yup.string().min(3, "town must be at least 3 characters"),
  business_address: yup
    .string()
    .min(10, "address must be at least 10 characters")
    .required("please enter address"),
  state: yup.string().required("please choose state"),
  city: yup.string().required("please choose city"),
});

export const policyGeneralInfoSchema = yup.object().shape({
  name: yup.string().required(),
  // category: yup.string().required(),
  short_name: yup.string().required("short name is required"),
  minimun_duration: yup
    .number()
    .typeError("This field accept numbers only")
    .required("minimum duration is required"),
  currency: yup.string().required(),
  // repayment_frequency: yup.string().required('repayment frequency is required'),
  minimum_age: yup
    .number()
    .typeError("This field accept numbers only")
    .required("Minimum age is required.")
    .test(
      "Is positive?",
      "The number must be greater than 0",
      (value) => value > 0
    ),
  maximum_age: yup
    .number()
    .typeError("This field accept numbers only")
    .max(100, "Value must be less than or equal to 100")
    .required("Maximum age is required.")
    .test(
      "Is positive?",
      "The number must be greater than 0",
      (value) => value > 0
    ),
});
export const creditLifeGeneralInfoSchema = yup.object().shape({
  name: yup.string().required(),
  // category: yup.string().required(),
  short_name: yup.string().required("short name is required"),
  minimun_duration: yup
    .number()
    .typeError("This field accept numbers only")
    .required("minimum duration is required"),
  currency: yup.string().required(),
  // repayment_frequency: yup.string().required('repayment frequency is required'),
});

export const savingsPolicyGeneralInfoSchema = yup.object().shape({
  policy_name: yup.string().required(),
  // category: yup.string().required(),
  short_name: yup.string().required("short name is required"),
  minimum_duration: yup
    .number()
    .typeError("This field accept numbers only")
    .required("minimum duration is required"),
  currency: yup.string().required(),
  // repayment_frequency: yup.string().required('repayment frequency is required'),
  minimum_age: yup
    .number()
    .typeError("This field accept numbers only")
    .required("Minimum age is required.")
    .test(
      "Is positive?",
      "The number must be greater than 0",
      (value) => value > 0
    ),
  maximum_age: yup
    .number()
    .typeError("This field accept numbers only")
    .max(100, "Value must be less than or equal to 100")
    .required("Maximum age is required.")
    .test(
      "Is positive?",
      "The number must be greater than 0",
      (value) => value > 0
    ),
});

export const interest = yup.object().shape({
  default_interest_rate: yup
    .number()
    .typeError("This field accept numbers only")
    .required("Defualt interest rate is required."),
  minimum_interest_rate: yup
    .number()
    .typeError("This field accept numbers only")
    .required("Minimum interest rate is required."),
  maximum_interest_rate: yup
    .number()
    .typeError("This field accept numbers only")
    .required("Maximum interest rate is required."),
});

export const cover = yup.object().shape({
  cover: yup
    .array()
    .of(yup.string().required("Input field is required"))
    .min(1, "Atleast one cover is required"),
});
export const settings = yup.object().shape({
  r_a_b: yup.string().required("Region/Area/Branch is required"),
});
export const savingsSettings = yup.object().shape({
  region_area_branch: yup.string().required("Region/Area/Branch is required"),
});
export const account = yup.object().shape({
  income_gl: yup
    .string("Income GL must be a string")
    .required("Income GL cannot be blank"),
  asset_gl: yup
    .string("Asset GL must be a string")
    .required("Asset GL cannot be blank"),
  libility_gl: yup
    .string("Policy Portfolio must be a string")
    .test(
      "not-same-as-overpayment",
      "Policy Portfolio must be different from Overpayment",
      function (value) {
        const over_payment_gl = this.parent.over_payment_gl;
        return value !== over_payment_gl;
      }
    )
    .required("Policy Portfolio cannot be blank"),
  over_payment_gl: yup
    .string("Overpayment must be a string")
    .test(
      "not-same-as-liability",
      "Overpayment must be different from Policy Portfolio",
      function (value) {
        const liabilityGL = this.parent.libility_gl;
        return value !== liabilityGL;
      }
    )
    .required("Overpayment cannot be blank"),
});

export const savingsAccount = yup.object().shape({
  income_gl: yup
    .string("Income GL must be a string")
    .required("Income GL cannot be blank"),
  asset_gl: yup
    .string("Asset GL must be a string")
    .required("Asset GL cannot be blank"),
  liability_gl: yup
    .string("Policy Portfolio must be a string")
    .required("Policy Portfolio cannot be blank"),
  interest_expense_gl: yup
    .string("Interest Expense must be a string")
    .test(
      "not-same-as-commission",
      "Interest Expense must be different from Commission",
      function (value) {
        const expense_gl = this.parent.expense_gl;
        return parseInt(value) !== expense_gl;
      }
    )
    .required("Interest Expense cannot be blank"),
});

export const policyEdit = policyGeneralInfoSchema
  .concat(interest)
  .concat(settings)
  .concat(account);
// .concat(cover);

export const savingsPolicyEdit = savingsPolicyGeneralInfoSchema
  .concat(interest)
  // .concat(savingsSettings)
  .concat(savingsAccount);

export const policyApplication = yup.object().shape({
  duration: yup.string().required(),
  effective_date: yup
    .string("effective date must be string value")
    .required("effective date is required"),
  repayment_frequency: yup
    .string("repayment frequency must be string value")
    .required("repayment frequency is required"),
  // total_annual_premium: yup
  //   .string()
  //   .required("total annual premium is required"),
});

export const riskcovered = yup.object().shape({
  cover_type: yup.string().required("cover type is required"),
  cover_for: yup.string().required("cover for is required"),
  rate: yup.string().required("rate is required"),
  sum_insured: yup
    .number()
    .typeError("sum insured must be a number")
    .required("sum insured is required"),
});

export const otherCovers = yup.object().shape({
  cover_id: yup.string().required("cover type is required"),
  rate: yup.string().required("rate is required"),
  sum_assured: yup
    .number()
    .typeError("sum assured must be a number")
    .required("sum assured is required"),
});

export const coverInfoSchema = yup.object().shape({
  date_of_loss: yup.string().required("date of loss is required"),
  // premium_paid_date: yup.string().required("premium paid date is required"),
  claim_amount: yup.string().required("claim amount is required"),
  // total_premium_paid: yup.string().required("total premium paid is required"),
  reason_for_claim: yup.string().required("reason for claim is required"),
});

// savings policy application
export const savingsPolicyApplication = yup.object().shape({
  duration: yup.string().required(),
  sum_assured: yup.string().required("sum assured is required"),
  interest_rate: yup.string().required("interest rate is required"),
  effective_date: yup
    .string("effective date must be string value")
    .required("effective date is required"),
  repayment_frequency: yup
    .string("repayment frequency must be string value")
    .required("repayment frequency is required"),
  covers: yup
    .array()
    .min(1, "At least one cover must be selected")
    .of(
      yup.object().shape({
        value: yup.string().required("Cover is required"),
        label: yup.string().required("Cover is required"),
      })
    ),
});
